import { subscribeToMessage } from '../../features/realtime/realtime.subscribe';
import {
  type RealtimeMessage,
  RealtimeMessageType,
  type RealtimeEvent,
} from '../../features/realtime/realtime.types';
import {
  type ScreenshareEventData,
  ScreenshareRequestPayload,
} from './screenshareState.types';
import { useCallback, useEffect } from 'react';
import { useScreenshareTransitions } from './useScreenshareTransitions';

export const useListenForScreenshare = (): void => {
  const {
    setReceivedRequest,
    setAcceptRequest,
    setRejectRequest,
    setCancelRequest,
    setStopScreenshare,
    setStoppedScreenshare,
  } = useScreenshareTransitions();

  const onScreenshareRequest = useCallback(
    (message: RealtimeMessage, event: RealtimeEvent): void => {
      const { eventName, eventData } = message.payload as {
        eventName: ScreenshareRequestPayload;
        eventData: ScreenshareEventData;
      };
      switch (eventName) {
        case ScreenshareRequestPayload.Request: {
          void setReceivedRequest(event.from.id);
          break;
        }
        case ScreenshareRequestPayload.Accept: {
          void setAcceptRequest();
          break;
        }
        case ScreenshareRequestPayload.Reject: {
          void setRejectRequest(eventData);
          break;
        }
        case ScreenshareRequestPayload.Cancel: {
          void setCancelRequest({ realtimeMemberId: event.from.id });
          break;
        }
        case ScreenshareRequestPayload.Stop: {
          void setStopScreenshare({ realtimeMemberId: event.from.id });
          break;
        }

        case ScreenshareRequestPayload.Stopped: {
          void setStoppedScreenshare();
          break;
        }

        default:
      }
    },
    [
      setReceivedRequest,
      setAcceptRequest,
      setRejectRequest,
      setCancelRequest,
      setStopScreenshare,
      setStoppedScreenshare,
    ],
  );

  useEffect(() => {
    const unsubscribe = subscribeToMessage({
      messageType: RealtimeMessageType.ScreenshareRequest,
      callback: onScreenshareRequest,
    });

    return () => unsubscribe();
  }, [onScreenshareRequest]);
};
